import type { ReactElement } from 'react';
import Announcement from '@/components/atoms/icons';

type descriptionType = {
  text: string;
  color: string;
};

function LayoutDescription(props: descriptionType): ReactElement {
  const { text, color } = props;

  return (
    <div className="LayoutDescription space-x-2">
      <span className="LayoutDescription__container">
        <Announcement color={color} width={20} height={20} />
      </span>

      <p>{text}</p>
    </div>
  );
}

export default LayoutDescription;
